import styles from "./page.module.css";

import { observer, inject } from "mobx-react";
import { useTranslation } from "react-i18next";
import { TransitionStore } from "../../store";
import { SubstatusDataStore } from "./store/store";
import SubstatusGrid from "./components/statuses-grid/manage-substatuses.grid";
import Header from "./components/header/header";
import { ViewItem, ViewSwitch } from "../../components/view-switch";
import DefaultStatusesGrid from "./components/default-statuses-grid/default-statuses.grid";
import { useEffect } from "react";
interface ISubstatusProps {
  substatusDataStore: SubstatusDataStore;
  transitionStore: TransitionStore;
}

function Substatuses(props: ISubstatusProps) {
  const { ready: readyCameraGrid } = useTranslation("substatus-grid");
  const { ready: readySearch } = useTranslation("search-substatus");
  const { ready: readyCommon } = useTranslation("common");
  const { transitionStore, substatusDataStore } = props;
  const {
    isDataLoading,
    isTranslationLoading,
    isSaveLoading,
    isDeleteLoading,
  } = substatusDataStore;

  const languagesLoaded = readyCameraGrid && readySearch && readyCommon;

  useEffect(() => {
    return () => {
      substatusDataStore.resetSelectedData();
      substatusDataStore.closeExpanded();
      transitionStore.isPromptShown = false;
    };
  }, []);

  useEffect(() => {
    if (!languagesLoaded) {
      substatusDataStore.setIsTranslationLoading(true);
    } else {
      substatusDataStore.setIsTranslationLoading(false);
    }

    if (
      isDataLoading ||
      isTranslationLoading ||
      isSaveLoading ||
      isDeleteLoading
    ) {
      transitionStore.setLoading(true);
    } else {
      transitionStore.setLoading(false);
    }
  });

  useEffect(() => {
    transitionStore.isPromptShown = substatusDataStore.hasSelectedSubstatus;
  }, [substatusDataStore.hasSelectedSubstatus]);

  const render = () => {
    return (
      <>
        {languagesLoaded && (
          <>
            <Header />
            <div
              id="grid-container"
              className={styles["manage-substatuses-grid-container"]}
            >
              <ViewSwitch activeKey={substatusDataStore.selectedTab}>
                <ViewItem itemKey={["manage-substatuses"]}>
                  <div className={styles["overflow-content"]}>
                    <SubstatusGrid />
                  </div>
                </ViewItem>
                <ViewItem itemKey={["default-substatuses"]}>
                  <div className={styles["overflow-content"]}>
                    <DefaultStatusesGrid />
                  </div>
                </ViewItem>
              </ViewSwitch>
            </div>
          </>
        )}
      </>
    );
  };

  return render();
}

export default inject(
  "substatusDataStore",
  "transitionStore"
)(observer(Substatuses));
